import React, { ReactNode, memo } from 'react';

interface DataBoxHolderProps {
    children: ReactNode;
}

const DataBoxHolder: React.FC<DataBoxHolderProps> = ({ children }) => {
    return (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4">
            {children}
        </div>
    );
};

export default memo(DataBoxHolder);

